<template>
  <div>
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <p class="uk-text-center uk-text-bold">Availability by Area</p>
      </div>
      <div class="uk-card-body uk-padding-remove">
        <div class="chart">
          <div class="chart-wrapper">
            <apexchart width="100%" height="200px" type="heatmap" :options="heatmap.chartOptions" :series="heatmap.series" />
          </div>
        </div>
      </div>
    </div>

    <div class="uk-width-xxlarge uk-margin-auto uk-card uk-card-default">
      <div class="uk-card-header">
        <p class="uk-text-center uk-text-bold">Incomplete Enquiries</p>
      </div>
      <div class="uk-card-body uk-padding-remove">
        <table-enquiry :filter="true" />
      </div>
    </div>
  </div>
</template>

<script>
import nowMixin from '@/utils/mixins/now'
import TableEnquiry from '@/components/table/Enquiry.vue'

export default {
  name: 'ComponentDashboardOperator',

  components: { TableEnquiry },

  mixins: [nowMixin],

  computed: {
    heatmap() {
      const response = {
        chartOptions: {
          chart: {
            id: 'week',
            toolbar: { show: false }
          },
          // colors: ['#00AAC5']
          plotOptions: {
            heatmap: {
              // enableShades: false,
              shadeIntensity: 0.2,
              colorScale: {
                ranges: [{
                  from: -1,
                  to: 1,
                  color: '#E71D36',
                  name: 'Not Available'
                },
                {
                  from: 1,
                  to: 999,
                  color: '#00AAC5',
                  name: 'Available'
                }]
              }
            }
          },
          // dataLabels: { enabled: false },
          xaxis: {
            tooltip: { enabled: false }
          },
          legend: { show: false }
        },
        series: []
      }

      const { now } = this
      let bits = []

      const todayBits = this.$helpers.timeBits.filter((b) => b.id >= now.time.id)
      const todayBitsMapped = todayBits.map((item) => ({ ...item, date: now.date.t }))

      // If bits include 16 or more elements remove non-needed elements
      // If bits include less than 16 elements add additional elements to fill all 16 bits
      if (todayBitsMapped.length >= 16) {
        bits = todayBitsMapped.slice(0, 16)
      } else {
        const tomorrowBits = this.$helpers.timeBits.slice(0, (16 - todayBitsMapped.length))
        const tomorrowDate = now.date.m.add(1, 'days').format('YYMMDD')

        const tomorrowBitsMapped = tomorrowBits.map((item) => ({ ...item, date: tomorrowDate }))

        bits = [...todayBitsMapped, ...tomorrowBitsMapped]
      }

      const temp = {}

      this.$helpers.areas.forEach((area) => {
        temp[area.uid] = []
        response.series.push({ name: area.name, data: [] })
      })

      bits.forEach((bit) => {
        this.$helpers.areas.forEach((area) => {
          temp[area.uid].push({
            x: bit.time.short,
            y: this.count(bit, area.uid)
          })
        })
      })

      response.series[0].data = temp['1']
      response.series[1].data = temp['2']

      return response
    },

    source() {
      const source = this.$store.state.dentists.collection

      // Availability Data with Area
      return source.map((dentist) => ({
        id: dentist.id,
        area: dentist.area,
        data: dentist.availability
      }))
    }
  },

  methods: {
    count(bit, area) {
      const filtered = this.source.filter((dentist) => dentist.area === area && dentist.data.hasOwnProperty(bit.date) && dentist.data[bit.date][bit.id] === 1)

      return filtered.length
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart {
    overflow-x: auto;

    .chart-wrapper {
      min-width: 600px;
    }
  }
</style>
